import React from 'react'
import { NavLink } from "react-router-dom";

export default function NavMenu() {
  return (
    <>
      <div className="container" id="nav">
        <nav className="navbar navbar-expand-lg navbar-light bg-light ">
           <div className="container">
      <NavLink exact to="/test" activeClassName="active" className="navbar-brand" >
        Тест
            </NavLink>
          </div>
        </nav>
        </div>
    </>
  );
}
